module.exports = () => {
  return {
    /** 模板名称 */
    template_name: {
      type: 'input',
      props: {
        placeholder: '请输入模板名称',
      },
      value: '',
    },
  };
};
